import * as React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormTextField } from "ui/Form";

import {
  READ_ACCOUNT_DEALER_INFO_QUERY,
  UPDATE_ACCOUNT_DEALER_INFO,
} from "graphqlQueries/accounts";

import { dealerInfoValidator } from "validators/dealerInfoValidator";

const fieldsWithError = [
  "name",
  "phone_number",
  "email_address",
  "address",
  "dealer_id",
];

const UpdateAccountDealerInfo = ({
  accountId,
  name,
  phone,
  email,
  address,
  dealerId,
  ...otherProps
}) => {
  const initialValues = React.useMemo(
    () => ({
      name,
      phone_number: phone,
      email_address: email,
      address,
      id_ipmp: accountId,
      dealer_id: dealerId,
    }),
    [],
  );

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_ACCOUNT_DEALER_INFO}
      refetchQueries={[READ_ACCOUNT_DEALER_INFO_QUERY]}
      initialValues={initialValues}
      validationSchema={dealerInfoValidator}
      title="Edit dealer info"
      submitButtonName="Save"
      className="dialog-default-width"
      fieldsWithPlaceForError={fieldsWithError}
      {...otherProps}
    >
      <FormTextField name="name" label="Name" />
      <FormTextField name="phone_number" label="Phone number" />
      <FormTextField name="email_address" label="Email" />
      <FormTextField name="address" label="Address" />
      <FormTextField name="dealer_id" label="Dealer ID" />
    </DialogFormWithMutation>
  );
};

UpdateAccountDealerInfo.propTypes = {
  accountId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  dealerId: PropTypes.number,
};

export default UpdateAccountDealerInfo;
